// Public shop base URL. In the desktop app the origin is 127.0.0.1:38173
// (hidden window if opened internally), so always point to the real domain.
export function shopBaseUrl() {
  const h = window.location.hostname;
  if (h === "127.0.0.1" || h === "localhost") return "https://sellox.shop";
  return window.location.origin;
}

export function cachedShopSlug(tenantId) {
  try { return localStorage.getItem(`shop_slug_${tenantId}`) || null; } catch { return null; }
}

export function setCachedShopSlug(tenantId, slug) {
  try { localStorage.setItem(`shop_slug_${tenantId}`, slug || ""); } catch { /* noop */ }
}

// Prefer the tenant's subdomain (leyenda.sellox.shop) once a slug is set — same form as the QR posters,
// so the wholesale link (…/mayor) in the admin follows the slug saved in system settings.
export function shopUrl(tenantId) {
  const slug = cachedShopSlug(tenantId);
  if (slug && shopBaseUrl().endsWith(BASE_DOMAIN)) return subdomainShopUrl(slug);
  return `${shopBaseUrl()}/shop/${slug || tenantId}`;
}

// Subdomain shop mode: esquina.sellox.shop -> slug "esquina"
const RESERVED_SUBS = new Set(["www", "backup", "beta", "api", "app", "admin", "mercado", "mail", "pos", "shop", "static", "cdn", "ftp", "smtp", "ns1", "ns2", "super"]);
const BASE_DOMAIN = "sellox.shop";

export function getShopSubdomain() {
  const h = window.location.hostname.toLowerCase();
  let sub = null;
  if (h !== BASE_DOMAIN && h.endsWith(`.${BASE_DOMAIN}`)) sub = h.slice(0, -(BASE_DOMAIN.length + 1));
  else if (h !== "localhost" && h.endsWith(".localhost")) sub = h.slice(0, -".localhost".length);
  if (!sub || sub.includes(".") || RESERVED_SUBS.has(sub)) return null;
  return sub;
}

export function subdomainShopUrl(slug) {
  return `https://${slug}.${BASE_DOMAIN}`;
}
